import { gql } from 'graphql.macro'
import PeriodFragment from '../../Periods/lib/PeriodFragment'
import ReadingTypeFragment from '../../ReadingTypes/lib/ReadingTypeFragment'
import ConditionFourthLayerFragment from '../../Conditions/lib/ConditionFourthLayerFragment'

export default gql`
  fragment TermThirdLayerFragment on Term {
    id
    type
    value

    period {
      ...PeriodFragment
    }

    readingType {
      ...ReadingTypeFragment
    }

    condition {
      ...ConditionFourthLayerFragment
    }
  }

  ${PeriodFragment}
  ${ReadingTypeFragment}
  ${ConditionFourthLayerFragment}
`
